import { Directive, ElementRef, HostBinding, Input, NgZone, Renderer2 } from '@angular/core';
import { toBoolean } from '../util/convert';
import { reqAnimFrame } from '../core/polyfill/request-animation';


export type NzTabPositionMode = 'horizontal' | 'vertical';
export class YztTabsInkBarDirective {
private _animated = false;
/**
 * @param {?} value
 * @return {?}
 */
set nzAnimated(value: boolean) {
    this._animated = toBoolean(value);
  }
/**
 * @return {?}
 */
get nzAnimated(): boolean {
    return this._animated;
  }

   nzPositionMode: NzTabPositionMode = 'horizontal';
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 * @param {?} _ngZone
 */
constructor(private _renderer: Renderer2,
private _elementRef: ElementRef,
private _ngZone: NgZone) {
  }
/**
 * @param {?} element
 * @return {?}
 */
alignToElement(element: HTMLElement): void {
    this.show();

    this._ngZone.runOutsideAngular(() => {
      reqAnimFrame(() => {
        /** when horizontal remove height style and add transfrom left **/
        if (this.nzPositionMode === 'horizontal') {
          this._renderer.removeStyle(this._elementRef.nativeElement, 'height');
          this._renderer.setStyle(this._elementRef.nativeElement, 'transform',
            `translate3d(${this._getLeftPosition(element)}, 0px, 0px)`);
          this._renderer.setStyle(this._elementRef.nativeElement, 'width',
            this._getElementWidth(element));
        } else {
          /** when vertical remove width style and add transfrom top **/
          this._renderer.removeStyle(this._elementRef.nativeElement, 'width');
          this._renderer.setStyle(this._elementRef.nativeElement, 'transform',
            `translate3d(0px, ${this._getTopPosition(element)}, 0px)`);
          this._renderer.setStyle(this._elementRef.nativeElement, 'height',
            this._getElementHeight(element));
        }
      });
    });
  }
/**
 * @return {?}
 */
show(): void {
    this._renderer.setStyle(this._elementRef.nativeElement, 'visibility', 'visible');
  }
/**
 * @param {?} value
 * @return {?}
 */
setDisplay(value: string): void {
    this._renderer.setStyle(this._elementRef.nativeElement, 'display', value);
  }
/**
 * @return {?}
 */
hide(): void {
    this._renderer.setStyle(this._elementRef.nativeElement, 'visibility', 'hidden');
  }
/**
 * @param {?} element
 * @return {?}
 */
_getLeftPosition(element: HTMLElement): string {
    return element ? element.offsetLeft + 'px' : '0';
  }
/**
 * @param {?} element
 * @return {?}
 */
_getElementWidth(element: HTMLElement): string {
    return element ? element.offsetWidth + 'px' : '0';
  }
/**
 * @param {?} element
 * @return {?}
 */
_getTopPosition(element: HTMLElement): string {
    return element ? element.offsetTop + 'px' : '0';
  }
/**
 * @param {?} element
 * @return {?}
 */
_getElementHeight(element: HTMLElement): string {
    return element ? element.offsetHeight + 'px' : '0';
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[yzt-tabs-ink-bar]',
  host: {
    '[class.ant-tabs-ink-bar]': 'true'
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
{type: NgZone, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'nzAnimated': [{ type: Input },{ type: HostBinding, args: ['class.ant-tabs-ink-bar-animated', ] },],
'nzPositionMode': [{ type: Input },],
};
}

function YztTabsInkBarDirective_tsickle_Closure_declarations() {
/** @type {?} */
YztTabsInkBarDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YztTabsInkBarDirective.ctorParameters;
/** @type {?} */
YztTabsInkBarDirective.propDecorators;
/** @type {?} */
YztTabsInkBarDirective.prototype._animated;
/** @type {?} */
YztTabsInkBarDirective.prototype.nzPositionMode;
/** @type {?} */
YztTabsInkBarDirective.prototype._renderer;
/** @type {?} */
YztTabsInkBarDirective.prototype._elementRef;
/** @type {?} */
YztTabsInkBarDirective.prototype._ngZone;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
